import React from 'react';
import PropTypes from 'prop-types';
import {
  Dimmer,
  Loader,
  Segment,
  Table,
} from 'semantic-ui-react';

const segmentStyle = { height: '100%', border: 'none' };
const noPadding = { padding: 0 };
const rowStyle = { border: 'none', boxShadow: 'none' };

const InfluencerTableLoadingRow = props => (
  <Table.Row style={rowStyle}>
    <Table.Cell colSpan={props.colSpan} height="500" style={noPadding}>
      <Segment style={segmentStyle}>
        <Dimmer active inverted>
          <Loader indeterminate>{ props.text }</Loader>
        </Dimmer>
      </Segment>
    </Table.Cell>
  </Table.Row>
);

InfluencerTableLoadingRow.defaultProps = {
  text: 'Loading...',
  colSpan: 13,
};

InfluencerTableLoadingRow.propTypes = {
  text: PropTypes.string,
  colSpan: PropTypes.number,
};


export default InfluencerTableLoadingRow;



/** WEBPACK FOOTER **
 ** ./src/components/influencer-table-loading-row/index.js
 **/